const BrowserBackNavigation = (storeNumber: string, storeId: string) => {
    if (storeNumber || storeId) {
        window.history.pushState(null, document.title, `${window.location.origin}/category`);
    } else {
        window.history.pushState(null, document.title, window.location.origin);
    }
};
export default BrowserBackNavigation;
